(function () {
    'use strict';

    angular
        .module('rms.common')
        .directive('rmsScheduler', rmsScheduler);

    function rmsScheduler() {
        return {
            restrict: 'E',
            controller: rmsSchedulerCtrl,
            controllerAs: 'schCtrl',
            scope: {
                options: '=',
                datasources: '=?',
                getModel: '=?',
                refresh: '=?',
                reload: '=?'
            },
            bindToController: true,
            templateUrl: 'common/app/components/scheduler/scheduler',
            // template:
            link: rmsSchedulerLink,
        };

        function rmsSchedulerLink(scope, elem) {

        }
    }

    function rmsSchedulerCtrl(lodash, GenericModel, $timeout, $scope) {
        var schCtrl = this;
        var date_format = 'YYYY-M-D';
        var time_format = 'h:mm A';
        this.$onInit = function() {
            schCtrl.reloads = false;

            schCtrl.timeslotpickerChange = timeslotpickerChange;
            schCtrl.getModel = getModel;
            schCtrl.refresh = refresh;
            schCtrl.reload = reload;
            schCtrl.form_display_type = 'inline';

            date_format = lodash.get(schCtrl.options, 'scheduler_settings.date_format', 'YYYY-M-D');
            time_format = lodash.get(schCtrl.options, 'scheduler_settings.time_format', 'h:mm A');
            // const date_time_format = date_format + ' ' + time_format;
            // let default_start_date = moment();
            // let default_end_date = moment().minutes(30);

            // if (lodash.has(schCtrl.options, 'scheduler_settings.start')) {
            //     default_start_date = moment(schCtrl.options.scheduler_settings.start, date_time_format);
            //     if (lodash.has(schCtrl.options, 'scheduler_settings.end')) {
            //         default_end_date = moment(schCtrl.options.scheduler_settings.end, date_time_format);
            //     } else {
            //         default_end_date = default_start_date.minutes(30);
            //     }
            // }

            // schCtrl.model = {
            //     start_date: default_start_date.format(date_format),
            //     start_time: default_start_date.format(time_format),
            //     end_date: default_end_date.format(date_format),
            //     end_time: default_end_date.format(time_format),
            //     time_zone: lodash.get(schCtrl.options, 'scheduler_settings.time_zone', ''),
            // };

            schCtrl.model = {
                start_date: '',
                start_time: '',
                end_date: '',
                end_time: '',
                time_zone: lodash.get(schCtrl.options, 'scheduler_settings.time_zone', ''),
            };

            schCtrl.time_slot_picker_options = lodash.get(schCtrl.options, 'scheduler_settings.time_slot_picker_options', {});

            schCtrl.scheduler_datasources = getDataSources();

            //this determines if we retrieve current date or range; set null for range
            schCtrl.current_date = new Date().toISOString();

            if (lodash.has(schCtrl.options, 'resources') && schCtrl.options.resources.length > 0) {
                angular.forEach(schCtrl.options.resources, function (resource) {
                    resource.dataSource = lodash.get(schCtrl.scheduler_datasources, resource.dataSource, {});
                });
            }
            setSchedulerOptions();
        }

        function getDataSources() {
            return lodash.reduce(schCtrl.datasources, function (result, datasource, index) {
                const ds = angular.copy(datasource);
                if (lodash.has(ds, 'transport.read')) {
                    if (lodash.has(ds.transport.read, 'url')) {
                        ds.transport.read = function (readOptions) {
                            var method = lodash.get(datasource.transport.read, 'method', 'query');
                            var url = lodash.get(datasource.transport.read, 'url', '');
                            var params = lodash.get(datasource.transport.read, 'params', {});
                            params.current_date = schCtrl.current_date;
                            var data = generateResourceOption(readOptions.data, params, method);
                            data.time_zone = schCtrl.model.time_zone;
                            var model = new GenericModel(url);
                            model[method](data).$promise.then(function (res) {
                                readOptions.success(res.data);
                            }, function (res) {
                                readOptions.error(res);
                            });
                        };
                    }
                }
                result[index] = ds;
                return result;
            }, {});
        }



        // if (lodash.has(vm.scheduler_datasources, vm.options.dataSource)) {
        //     vm.options.dataSource = vm.scheduler_datasources[vm.options.dataSource];
        // }

        function setSchedulerOptions() {
            var dateTimeConfig = {};
            if (lodash.has(schCtrl.options, 'workDayStart')) {
                dateTimeConfig.workDayStart = new Date(schCtrl.options.workDayStart);
            }
            if (lodash.has(schCtrl.options, 'workDayEnd')) {
                dateTimeConfig.workDayEnd = new Date(schCtrl.options.workDayEnd);
            }

            schCtrl.scheduler_options = angular.extend(
                {
                    change: function (eData) {
                        if (lodash.isEmpty(eData.resources.ownerId.toString())) {
                            setModel(eData);
                        }
                    },
                    navigate: function (e) {
                        schCtrl.current_date = e.date.toISOString();
                        refresh();
                    }
                },
                schCtrl.options,
                {
                    dataSource: lodash.get(schCtrl.scheduler_datasources, schCtrl.options.dataSource, {
                        data: [],
                    })
                },
                dateTimeConfig
            );
        }

        function generateResourceOption(resourceData, myData, method) {
            var params = {};
            params = angular.merge(params, resourceData, myData);
            if (method == 'search') {
                params = {'data': params};
            }
            return params;
        }

        function timeslotpickerChange() {
            // var start = moment(schCtrl.model.start_date + ' ' + schCtrl.model.start_time, date_time_format);
            // var end = moment(schCtrl.model.end_date + ' ' + schCtrl.model.end_time, date_time_format);
            // schCtrl.schedulerObj.select({
            //     start: start.toDate(),
            //     end: end.toDate(),
            //     resources: [0]
            // })
        }

        function setModel(schedulerDatetimeObj) {
            $scope.$apply(function () {
                var start = moment(schedulerDatetimeObj.start);
                var end = moment(schedulerDatetimeObj.end);
                schCtrl.model.start_date = start.format(date_format);
                schCtrl.model.start_time = start.format(time_format);
                schCtrl.model.end_date = end.format(date_format);
                schCtrl.model.end_time = end.format(time_format);
                schCtrl.render();
            });
        }

        function getModel() {
            return schCtrl.model;
        }

        function refresh() {
            // schCtrl.reloads = true;
            schCtrl.schedulerObj.dataSource.read().then(function (e) {
                // $timeout(function () {
                //     schCtrl.reloads = false;
                // })
            })
        }

        function reload() {
            schCtrl.reloads = true;
            $timeout(function () {
                setSchedulerOptions();
                schCtrl.reloads = false;
            });
        }
    }
})();